import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

export type DeviceType = "A920" | "A920Pro" | "A77"
export type Device = {
  id: number
  serialNumber: string
  name: string
  appVersion: string | null
  deviceType: DeviceType
}

export type DeviceFilters = Record<string, never>

export const listDevices = async (
  query: DeviceFilters = {}
): Promise<Device[]> => {
  const response = await api.get<Device[]>("/devices/", {
    query,
  })
  return response.body
}

export const useDevices = (
  filters: MaybeRef<DeviceFilters> = {}
) => {
  const { data, ...useQueryReturns } = useQuery({
    queryKey: [BASE_DEVICES_QUERY_KEY, filters] as const,
    queryFn: ({ queryKey: [_, filters_] }) =>
      listDevices(unref(filters_)),
    staleTime: 60 * 60 * 1000,
  })

  const getById = (
    id: MaybeRef<number | null | undefined>
  ) =>
    computed(() => {
      if (!unref(id)) return
      if (data.value === undefined) return

      return data.value.find(
        (device) => device.id === unref(id)
      )
    })

  return {
    data: data,
    ...useQueryReturns,
    getById,
  }
}
